import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Dropdown } from "./components/Dropdown";
import { CategoriesItemRC, CategoriesLinksRC, CategoriesListRC } from "../../../../../../connected";
export var Categories = function Categories(_ref) {
  var activeCategory = _ref.activeCategory,
    setActiveCategory = _ref.setActiveCategory;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var handleCategoryClick = function handleCategoryClick(category) {
    setIsOpen(false);
    setActiveCategory(category);
  };
  return /*#__PURE__*/React.createElement(Dropdown, {
    isOpen: isOpen,
    onClick: function onClick() {
      return setIsOpen(function (prev) {
        return !prev;
      });
    },
    title: activeCategory.title,
    "data-t-id": "components-Categories"
  }, /*#__PURE__*/React.createElement(CategoriesListRC, {
    "data-t-id": "components-Categories"
  }, /*#__PURE__*/React.createElement(CategoriesItemRC, {
    onClick: handleCategoryClick,
    "data-t-id": "components-Categories"
  })), /*#__PURE__*/React.createElement(CategoriesLinksRC, null));
};